<coa-heading-1>
  <div left>
    <coa-select-category-filter
      (filterUpdated)="categoryUpdated($event)"
      *coaFeatureToggleDisable="toggle; clientId: clientId"
      [categoryId]="categoryId"
      [clientId]="clientId"
      class="select-category-filter">
    </coa-select-category-filter>
  </div>

  <div right>
    <coa-select-date-range-filter
      (filterUpdated)="dateRangeUpdated($event)"
      [clientId]="clientId"
      [dateRange]="dateRange"
      class="select-date-range-filter">
    </coa-select-date-range-filter>
  </div>
</coa-heading-1>
